<template>
    <div>
        <div v-if="loading" class="loading"/>

        <div v-else>
            <div class="top-right-button-container">
                <b-button-group class="mb-2">
                    <b-button @click="vendorStatus" size="sm" variant="outline-primary">
                        Change Status
                    </b-button>

                    <b-button @click="vendorComment" size="sm" variant="outline-primary">
                        Add Comment
                    </b-button>

                    <b-dropdown size="sm" variant="primary" right :text="'More'">
                        <b-dropdown-item @click="editVendor(vendor.vendor_id)">Edit</b-dropdown-item>

                        <b-dropdown-item @click="deleteVendor(vendor)">Delete</b-dropdown-item>
                    </b-dropdown>
                </b-button-group>
            </div>

            <div class="d-flex flex-row">
                <span class="iconsminds-hotel mr-3 menu-icon-style" style="font-size: 23px;" />

                <piaf-breadcrumb :heading="vendor.data.attributes.name"/>

<!--                <p class="my-auto">-->
<!--                    Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet commodi dolores quod,-->
<!--                    repellendus similique sint. Ad, corporis culpa delectus est in ipsum laboriosam nostrum-->
<!--                    officiis quia quos rem totam vitae.-->
<!--                </p>-->
            </div>

            <b-tabs nav-class="separator-tabs ml-0 mb-4" content-class="tab-content" :no-fade="true">
                <b-tab title="SUMMARY" @click="getSummary" :active="$route.name === 'vendors.show'">
                    <b-row>
                        <b-colxx xxs="12" lg="4">
                            <b-card no-body>
                                <b-card-body>
                                    <div class="mt-3">
                                        <span class="card-subtitle text-one">Summary of</span><br>
                                        <h4 class="bold">{{vendor.data.attributes.name}}</h4>
                                        <b-badge
                                            :variant="vendor.data.attributes.status === 'Active' ? 'info' : 'danger'"
                                            pill class="position-absolute badge-top-left">
                                            {{ vendor.data.attributes.status }}
                                        </b-badge>
                                    </div>
                                </b-card-body>
                                <div class="position-relative">
                                    <img src="/default/vendor_profile_pic.jpg" alt="Detail" class="card-img-top"/>
                                </div>
                                <b-card-body>
                                    <h4 class="mb-4">Details</h4>

                                    <p>
                                        <ListForSummary :icon="'iconsminds-geo2--'" :title="'Address'"
                                                        :border-bottom="true"
                                                        :content="vendor.data.attributes.address"/>
                                        <ListForSummary :icon="'iconsminds-calendar-4'" :title="'Date'"
                                                        :border-bottom="true"
                                                        :content="vendor.data.attributes.date"/>
                                        <ListForSummary :icon="'iconsminds-male-female'" :title="'Contact Name'"
                                                        :border-bottom="true"
                                                        :content="vendor.data.attributes.contact"/>
                                        <ListForSummary :icon="'iconsminds-mail-with-at-sign'" :title="'Email'"
                                                        :border-bottom="true"
                                                        :content="vendor.data.attributes.email"/>
                                        <ListForSummary :icon="'iconsminds-smartphone-4'" :title="'Phone'"
                                                        :border-bottom="true"
                                                        :content="vendor.data.attributes.phone"/>
                                        <ListForSummary :icon="'iconsminds-fax'" :title="'Fax'"
                                                        :content="vendor.data.attributes.fax"/>
                                    </p>
                                    <p class="text-muted text-small mb-2">Notes</p>
                                    <p>{{vendor.data.attributes.notes}}</p>
                                </b-card-body>
                            </b-card>
                        </b-colxx>

                        <b-colxx xxs="12" lg="8">
                            <b-row class="mb-4">
                                <b-colxx xxs="4">
                                    <radial-progress-card
                                        :title="'Facilities | ' + stats.data.attributes.total_facilities.count"
                                        secondary-title="Total"
                                        :percent="stats.data.attributes.total_facilities.percentage"
                                        no-suffle=""/>
                                </b-colxx>
                                <b-colxx xxs="4">
                                    <radial-progress-card
                                        :title="'Units | ' + stats.data.attributes.total_units.count"
                                        secondary-title="Total"
                                        :percent="stats.data.attributes.total_units.percentage"
                                        no-suffle=""/>
                                </b-colxx>
                                <b-colxx xxs="4">
                                    <radial-progress-card
                                        :title="'Inspections | ' + stats.data.attributes.total_inspections.count"
                                        secondary-title="Total"
                                        :percent="stats.data.attributes.total_inspections.percentage"
                                        no-suffle=""/>
                                </b-colxx>
                            </b-row>

                            <b-row class="m-0 mb-4 sep-border-bottom">
                                <b-colxx xxs="2" class="half-sep-border-right">
                                    <h6 class="mb-n2">Facilities<br>
                                        <small class="text-muted">Active</small>
                                    </h6>
                                    <span class="text-muted" style="font-size: 30px">
                                        {{ stats.data.attributes.active_facilities.count }}
                                    </span>
                                </b-colxx>

                                <b-colxx xxs="2" class="half-sep-border-right">
                                    <h6 class="mb-n2">Units<br>
                                        <small class="text-muted">Active</small>
                                    </h6>
                                    <span class="text-muted" style="font-size: 30px">
                                        {{ stats.data.attributes.active_units.count }}
                                    </span>
                                </b-colxx>

                                <b-colxx xxs="2" class="half-sep-border-right">
                                    <h6 class="mb-n2">Single<br>
                                        <small class="text-muted">Units</small>
                                    </h6>
                                    <span class="text-muted" style="font-size: 30px">
                                        {{ stats.data.attributes.single_units.count }}
                                    </span>
                                </b-colxx>

                                <b-colxx xxs="2" class="half-sep-border-right">
                                    <h6 class="mb-n2">Family<br>
                                        <small class="text-muted">Units</small>
                                    </h6>
                                    <span class="text-muted" style="font-size: 30px">
                                        {{ stats.data.attributes.family_units.count }}
                                    </span>
                                </b-colxx>

                                <b-colxx xxs="2" class="half-sep-border-right">
                                    <h6 class="mb-n2">Occupied<br>
                                        <small class="text-muted">Units</small>
                                    </h6>
                                    <span class="text-muted" style="font-size: 30px">
                                        {{ stats.data.attributes.occupied_units.count }}
                                    </span>
                                </b-colxx>

                                <b-colxx xxs="2">
                                    <h6 class="mb-n2">Vacant<br>
                                        <small class="text-muted">Units</small>
                                    </h6>
                                    <span class="text-muted" style="font-size: 30px">
                                        {{ stats.data.attributes.vacant_units.count }}
                                    </span>
                                </b-colxx>
                            </b-row>

                            <b-card v-if="$route.name === 'vendors.show'" class="mb-4">
                                <div class="d-flex flex-row">
                                    <i class="iconsminds-line-chart-3 text-large mb-4 mr-3 menu-icon-style"/>
                                    <div class="my-auto">
                                        <div class="d-inline-block mb-4">
                                            <h5 class="d-inline">BILLINGS</h5>
                                            <span class="text-muted text-small d-block">Last Six Months</span>
                                        </div>
                                    </div>
                                </div>

                                <area-shadow-chart :data="billingChartData" :prefix="'$'" :height="220"/>
                            </b-card>

                            <b-card no-body>
                                <b-tabs card fade>
                                    <b-tab title="Comments" active>
                                        <vue-perfect-scrollbar v-if="comments.length > 0" class="scroll comments-list"
                                                               :settings="{ suppressScrollX: true, wheelPropagation: false }">
                                            <CommentsList v-for="(comment, index) in comments" :data="comment"
                                                          :key="index" @edit="editComment"
                                                          @delete="deleteComment(comment)"/>
                                        </vue-perfect-scrollbar>

                                        <div v-else>
                                            <p>No comments found.</p>
                                        </div>
                                    </b-tab>

                                    <b-tab title="History">
                                        <vue-perfect-scrollbar v-if="histories.length > 0" class="scroll histories-list"
                                                               :settings="{ suppressScrollX: true, wheelPropagation: false }">
                                            <HistoriesList :data="histories"/>
                                        </vue-perfect-scrollbar>

                                        <div v-else>
                                            <p>No histories found.</p>
                                        </div>
                                    </b-tab>
                                </b-tabs>
                            </b-card>
                        </b-colxx>
                    </b-row>
                </b-tab>

                <b-tab title="FACILITIES" @click="getFacilities" :active="$route.name === 'vendors.facilities'">
                    <router-view v-if="$route.name === 'vendors.facilities'"/>
                </b-tab>

                <b-tab title="UNITS" @click="getUnits" :active="$route.name === 'vendors.units'">
                    <router-view v-if="$route.name === 'vendors.units'"/>
                </b-tab>

                <b-tab title="ADMISSIONS" @click="getAdmissions" :active="$route.name === 'vendors.admissions'">
                    <router-view v-if="$route.name === 'vendors.admissions'"/>
                </b-tab>

                <b-tab title="INSPECTIONS" @click="getInspections" :active="$route.name === 'vendors.inspections'">
                    <router-view v-if="$route.name === 'vendors.inspections'"/>
                </b-tab>

                <b-tab title="BILLINGS" @click="getBillings" :active="$route.name === 'vendors.billings'">
                    <router-view v-if="$route.name === 'vendors.billings'"/>
                </b-tab>
            </b-tabs>

            <VendorFormModal :edit="true" @updated="getVendor(vendor.vendor_id)"/>

            <VendorOtherModal :vendor="vendor" :edit="comment_edit" :mode="modalMode" @close="resetOtherModal"
                              @updated="getVendor(vendor.vendor_id)"/>

            <VendorDeleteModal :mode="delete_mode" :comment="selected_comment" :vendor="vendor"
                               @deleted-vendor="$router.push('/hms/vendors')"
                               @deleted-comment="getVendor(vendor.vendor_id)"/>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';

    import VendorFormModal from "./modals/VendorFormModal";
    import VendorDeleteModal from "./modals/VendorDeleteModal";
    import VendorOtherModal from "./modals/VendorOtherModal";

    import ListForSummary from "../../../components/Listing/ListForSummary";
    import RadialProgressCard from '../../../components/Cards/RadialProgressCard';
    import AreaShadowChart from '../../../components/Charts/AreaShadow';
    import CommentsList from "../../../components/Listing/CommentsList";
    import HistoriesList from "../../../components/Listing/HistoriesList";

    export default {
        name: "VendorSummary",
        components: {
            VendorFormModal,
            VendorDeleteModal,
            VendorOtherModal,
            CommentsList,
            ListForSummary,
            RadialProgressCard,
            AreaShadowChart,
            HistoriesList,
        },
        data() {
            return {
                loading: true,
                modalMode: '',
                delete_mode: null,
                selected_comment: null,
                comment_edit: false,
            }
        },
        computed: {
            ...mapGetters({
                vendor: 'getVendor',
                stats: 'getVendorStats',
                comments: 'getVendorComments',
                histories: 'getVendorHistories',
                form: 'getVendorForm',
                colors: 'getThemeColors',
            }),

            billingChartData() {
                let payload = this.stats.data.attributes.billings;

                return {
                    labels: payload.labels,
                    datasets: [{
                        data: payload.data,
                        borderColor: this.colors.themeColor1,
                        pointBackgroundColor: this.colors.foregroundColor,
                        pointBorderColor: this.colors.themeColor1,
                        pointHoverBackgroundColor: this.colors.themeColor1,
                        pointHoverBorderColor: this.colors.foregroundColor,
                        backgroundColor: this.colors.themeColor1_10,
                        pointRadius: 4,
                        pointBorderWidth: 2,
                        pointHoverRadius: 5,
                        fill: true,
                        borderWidth: 2
                    }],
                };
            },
        },
        mounted() {
            this.getVendor(this.$route.params.vendor_id);
        },
        methods: {
            async getVendor(vendor_id) {
                await this.$store.dispatch('fetchVendor', vendor_id)
                    .catch(error => {
                        this.$router.push('/error');
                    });

                await this.$store.dispatch('fetchVendorStats', vendor_id);

                await this.$store.dispatch('fetchVendorComments', vendor_id);

                await this.$store.dispatch('fetchVendorHistories', vendor_id);

                return this.loading = false;
            },

            editVendor(vendor_id) {
                this.$store.dispatch('fetchEditVendor', vendor_id)
                    .finally(response => {
                        this.$bvModal.show('vendor_form');
                    });
            },

            deleteVendor() {
                this.delete_mode = 'vendor';

                setTimeout(() => {
                    this.$bvModal.show('vendor_delete');
                }, 1);
            },

            vendorStatus() {
                this.modalMode = 'status';
                this.$bvModal.show('vendor_other');
            },

            vendorComment() {
                this.modalMode = 'comment';
                this.$bvModal.show('vendor_other');
            },

            hideModal(refName) {
                this.$refs[refName].hide();
            },

            getSummary() {
                if (this.$route.name !== 'vendors.show') {
                    this.$router.push({name: 'vendors.show'});
                }
            },

            getFacilities() {
                if (this.$route.name !== 'vendors.facilities') {
                    this.$router.push({name: 'vendors.facilities'});
                }
            },

            getUnits() {
                if (this.$route.name !== 'vendors.units') {
                    this.$router.push({name: 'vendors.units'});
                }
            },

            getAdmissions() {
                if (this.$route.name !== 'vendors.admissions') {
                    this.$router.push({name: 'vendors.admissions'});
                }
            },

            getInspections() {
                if (this.$route.name !== 'vendors.inspections') {
                    this.$router.push({name: 'vendors.inspections'});
                }
            },

            getBillings() {
                if (this.$route.name !== 'vendors.billings') {
                    this.$router.push({name: 'vendors.billings'});
                }
            },

            editComment(comment_id) {
                this.comment_edit = true;

                this.$store.dispatch('fetchEditVendorComment', comment_id)
                    .finally(response => {
                        this.$bvModal.show('vendor_other');
                    });
            },

            deleteComment(comment) {
                this.selected_comment = comment;
                this.delete_mode = 'comment';

                setTimeout(() => {
                    this.$bvModal.show('vendor_delete');
                }, 1);
            },

            resetOtherModal() {
                this.comment_edit = false;
                this.modalMode = '';
            },
        },
    }
</script>

<style scoped>

</style>
